import React from 'react'
import icon from "../../assets/Images/SuccessModalApproval/icon.png"
import { Modal } from 'flowbite-react'
import { handoffToApp } from '../../utils/landingAuth'

const SuccessModalApproval = ({ openSuccess, onGoToDashboard, onDismiss }) => {

    const navToDashboard = () => {
        handoffToApp({ target: '/visitor/visitorPage' })
        onGoToDashboard?.()
    }

    return (
        <Modal className='font-poppins' show={openSuccess} size="lg" popup onClose={onDismiss}>

            <Modal.Body className='bg-[#F3D8D5] rounded-md '>
                <div className=' flex flex-col items-center'>
                    <img src={icon} className='w-full' alt="" />
                    <h2 className='text-2xl font-bold'>You're all set!</h2>
                    <p className='text-sm mt-3 text-center mb-4'>
                        Your company has been registered. Continue to the dashboard to complete your profile, choose a plan, and set your password.
                    </p>
                    <button
                        type="button"
                        className='px-3 py-2 border-[2px] border-primaryColor rounded-md bg-white'
                        onClick={navToDashboard}
                    >
                        Go to Dashboard
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default SuccessModalApproval
